import { useEffect, useState , useCallback , Fragment } from "react";
import { connect } from "react-redux";
import { addProductToCart , increaseProduct } from '../../store/actions/index';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';

const Container = styled.div`
    min-height: 100vh;
    padding: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const CardWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    flex-grow:1;
    padding: 50px 40px 50px;
    border-radius: 8px;
    text-transform: capitalize;
    max-width: 80%;
    margin: 0 auto ;
    @media screen and (max-width: 992px) {
        flex-direction: column;
    }
    @media screen and (max-width: 768px) {
        padding: 40px 20px
    }
`;
const ProductImg = styled.div`
    min-height: 300px;
    background-color: ${ props => props.colorValue};
    border-radius: 8px;
    flex-basis: 45%;
    @media screen and (max-width: 992px) {
        margin-bottom: 30px;
        width: 100%;
    }
`;
const ProductBody = styled.div`
    padding-left: 40px;
    flex-basis: 45%;
    @media screen and (max-width: 992px) {
        padding-left: 0;
    }
`;

const ProductName = styled.h1`
    font-size: 28px;
    line-height: 1.4;
    margin-top : 0;
    margin-bottom: 10px;
    color: #333;
    text-align: left;
`
const ProductCat = styled.h2`
    font-size: 20px;
    line-height: 1.4;
    margin-top : 0;
    font-weight: 600;
    margin-bottom: 10px;
    color: #9b9b9b;
    text-align: left;
`
const ProductPrice = styled.p`
    font-size: 24px;
    line-height: 1.4;
    margin-top : 0;
    margin-bottom: 20px;
    color: #ff3838;
    font-weight: 600;
    text-align: left;
`
const ProductDesc = styled.p`
    font-size: 18px;
    line-height: 1.4;
    margin-top : 0;
    margin-bottom: 20px;
    color: #9b9b9b;
    font-weight: 400;
    text-align: left;
`

const ProductAction = styled.div`
    display: flex;
    align-items: center;
`;
const Button = styled.button`
    font-size:15px;
    height: 48px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding :0px 20px;
    background-color: ${ props => props.primary ? '#027897' : '#ff5722' };
    color: #fff;
    border:0;
    outline: none;
    cursor: pointer;
    text-transform: capitalize;
    border-radius: 4px;
    transition: 0.3s ease-in-out;
    margin-left: 20px;
    flex-shrink: 0;
    &:hover {
        background-color: #f44040;
    }
`

const ProductDetails = ( props) => {

    const { match , fetchedProducts , cartItems , increaseProductQuantity , buyProductHandler } = props;

    const [ selectedProduct , setSelectedProduct ] = useState(null);

    const [ addedQunatity , setAddedQuantity ] = useState(1);

    const [ validQunatity , setValidQuantity ] = useState(true);

    // Add Product Data Based On Query Params
    useEffect(() => {
        const itemIndex =  fetchedProducts.findIndex( item => item.id === match.params.id );
        setSelectedProduct(fetchedProducts[itemIndex])
    }, [ fetchedProducts , match ])

    // Validate The Number TO Pass Only Positive Nums
    const validateAddedQuantityHandler = useCallback(
        (event) => {
            setAddedQuantity(event.target.value);
            event.target.value <= 0  ? setValidQuantity(false) : setValidQuantity(true) 
        }
        , [ ]
    )

    const addProductHandler = useCallback( ( event , id , quantity = 1 ) => {
        event.preventDefault();
        let addedProduct = null ;
        if ( cartItems.some( item => item.id === id ) ) {
            const orderIndex =  cartItems.findIndex( item => item.id === id )
            increaseProductQuantity( cartItems[orderIndex].orderId , cartItems[orderIndex].quantity + +quantity , +quantity );
        } else {
            const productIndex =  fetchedProducts.findIndex( item => item.id === id );
            addedProduct = {...fetchedProducts[productIndex] , quantity: +quantity};
            buyProductHandler(addedProduct , +quantity);
        }
    }, [ buyProductHandler , fetchedProducts , cartItems ,increaseProductQuantity ]);


    let productContent = <CircularProgress />

    if ( selectedProduct ) {
        productContent = (
            <Fragment>
                <ProductImg colorValue={`#${selectedProduct.imageColor}`}/>
                <ProductBody>
                    <ProductName>{selectedProduct.name}</ProductName>
                    <ProductCat>{selectedProduct.category}</ProductCat>
                    <ProductPrice>{selectedProduct.price}</ProductPrice>
                    <ProductDesc>{selectedProduct.description}</ProductDesc>
                    <form onSubmit={ ( event ) => addProductHandler(event , selectedProduct.id , addedQunatity)}>
                        <ProductAction>
                            <TextField id="standard-number" label="Quantity" type="number" value={addedQunatity} 
                                onChange={validateAddedQuantityHandler}
                                InputLabelProps = {{  shrink: true, }} />
                            <Button disabled={!validQunatity} >add to cart</Button>
                        </ProductAction>
                    </form>
                </ProductBody>
            </Fragment>
        )
    }

    return (
        <Container>
            <CardWrapper>
                {productContent}
            </CardWrapper>
        </Container>
    )
}

const mapStateToProps = state =>{
    return {
        fetchedProducts: state.prod.products,
        cartItems: state.cart.cartItems,
    }
}

const mapDispatchToProps = dispatch =>{
    return {
        buyProductHandler: ( ( product , quantity ) => dispatch( addProductToCart( product , quantity ) )),
        increaseProductQuantity : ( id, quantity, quantityAdded ) => dispatch ( increaseProduct(  id, quantity, quantityAdded ) )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);